import React from 'react';
import { checkMedia } from '../../componentUtils';
import LoadingVideo from '../LoadingVideo/LoadingVideo';
import { useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import { shallowEqual } from 'react-redux';

type FeaturedVideoProps = {
	src: string | boolean;
};
const FeaturedVideo: React.FC<FeaturedVideoProps> = ({ src }) => {
	const network_status = useAppSelector(
		(state: RootState) => state.network.status,
		shallowEqual,
	);
	return (
		<>
			{network_status && (
				<div className="pa3">
					<LoadingVideo src={checkMedia(src)} />
					{/* <video controls preload="auto">
						<source src={checkMedia(src)}></source>
					</video> */}
				</div>
			)}
		</>
	);
};

export default FeaturedVideo;
